<template>
  <q-btn
    :dense="dense"
    :disable="disable"
    flat
    :icon="icon"
    :label="label"
    :no-caps="noCaps"
    :padding="padding"
    :size="size"
    square
    :text-color="textColor"
    :type="type"
  >
    <slot />
  </q-btn>
</template>

<script>
export default {
  name: 'CancelButton',
  props: {
    dense: Boolean,
    disable: Boolean,
    icon: String,
    label: String,
    noCaps: Boolean,
    padding: String,
    size: String,
    textColor: {
      type: String,
      default: 'dark',
    },
    type: String,
  },
};
</script>
